<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <ShipperEditForm :account-id="accountId" />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import ShipperEditForm from '@/components/Application/Manage/Account/ShipperEditForm'

export default {
  components: {
    ShipperEditForm
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      breadcrumb: {
        name: 'Shipper',
        route: { name: 'manage-accounts-account-configurations-shipper', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
